<template>
  <div class="material" v-if="item">
    <div class="material__image-container">
      <div class="material__category">
        <span>
          {{ typeName }}
        </span>

        <Favorite
          v-if="!hideFavorites && item.ct !== 'custom_card'"
          class="ml-auto"
          :watchLater="item.watch_later"
          :favorite="item.favorite"
          @watchLater="
            watchLater(item.watch_later ? 'DELETE' : 'POST', item.id, item.ct)
          "
          @favorite="
            favorite(item.favorite ? 'DELETE' : 'POST', item.id, item.ct)
          "
        />
      </div>
      <img
        @click="goTo()"
        class="material__preview"
        v-if="!hideImage"
        :src="
          item.image ||
          'https://storage.yandexcloud.net/sb-dev-most-static-01/media/uploads/materials/announce/2023/01/09/Frame_483849_e2BGTkQ.jpeg'
        "
      />
    </div>
    <div class="material__text-container" @click="goTo()">
      <div class="material__tags" v-if="false">
        <div
          class="material__tag"
          v-for="(nosology, i) in item.nosology"
          :key="`nos${i}`"
          v-html="nosology.title"
        ></div>
        <div
          class="material__tag"
          v-for="(disease, i) in item.disease"
          :key="`dis${i}`"
          v-html="disease.title"
        ></div>
      </div>
      <div class="material__diseases">
        <div
          class="material__disease"
          v-for="(disease, i) in item.disease"
          :key="`dis${i}`"
          v-html="disease.title"
        ></div>
      </div>
      <div class="material__title" v-html="item.name || item.title"></div>
      <div class="material__brands" v-if="item.brands.length">
        <div
          class="material__brand"
          v-for="(nosology, i) in item.brands"
          :key="`nos${i}`"
          v-html="nosology.title"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import Favorite from "./Favorite.vue";
import { mapActions } from "vuex";
export default {
  data: () => ({
    count: 0,
  }),
  components: { Favorite },
  name: "Material",
  props: {
    item: Object,
    hideImage: {
      type: Boolean,
      default: false,
    },
    hideFavorites: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    types: {
      podcast: {
        routeName: "PodcastDetail",
        typeName: "Подкаст",
      },
      video: {
        routeName: "VideoDetail",
        typeName: "Видео",
      },
      project: {
        routeName: "Project",
        typeName: "Проект",
      },
      text: {
        routeName: "TextDetail",
        typeName: "Статья",
      },
      drug: {
        routeName: "DrugsTemplates",
        typeName: "Препарат",
      },
    },
  }),
  computed: {
    typeName() {
      if (this.types[this.item.ct]) return this.types[this.item.ct].typeName;
      if (this.item.tags) return this.item.tags;
      return "";
    },
    link() {
      if (this.types[this.item.ct]) {
        const route = this.$router.resolve({
          name: this.types[this.item.ct].routeName,
          params: { slug: this.item.slug },
        });
        if (route.resolved.matched.length) return route.href;
        else if (this.item.url) return this.item.url;
      } else if (this.item.url) return this.item.url;
    },
  },
  methods: {
    ...mapActions([
      "fetchVideoFavorite",
      "fetchPodcastFavorite",
      "fetchTextFavorite",
      "fetchMedicationFavorite",
      "fetchProjectFavorite",
      "fetchVideoWatchLater",
      "fetchPodcastWatchLater",
      "fetchTextWatchLater",
      "fetchMedicationWatchLater",
      "fetchProjectWatchLater",
    ]),
    async watchLater(method, slug, type) {
      switch (type) {
        case "project":
          await this.fetchProjectWatchLater({
            method: method,
            id: slug,
            favoritePage: true,
          });
          break;
        case "video_material":
          await this.fetchVideoWatchLater({
            method: method,
            slug: slug,
            favoritePage: true,
          });
          break;
        case "podcast":
          await this.fetchPodcastWatchLater({
            method: method,
            slug: slug,
            favoritePage: true,
          });
          break;
        case "text_material":
          await this.fetchTextWatchLater({
            method: method,
            slug: slug,
            favoritePage: true,
          });
          break;
        case "drug":
          await this.fetchMedicationWatchLater({
            method: method,
            slug: slug,
            favoritePage: true,
          });
          break;
      }
      await this.getRecommendations(this.user.id);
    },
    async favorite(method, slug, type) {
      switch (type) {
        case "project":
          await this.fetchProjectFavorite({
            method: method,
            id: slug,
            favoritePage: true,
          });
          break;
        case "video_material":
          await this.fetchVideoFavorite({
            method: method,
            slug: slug,
            favoritePage: true,
          });
          break;
        case "podcast":
          await this.fetchPodcastFavorite({
            method: method,
            slug: slug,
            favoritePage: true,
          });
          break;
        case "text_material":
          await this.fetchTextFavorite({
            method: method,
            slug: slug,
            favoritePage: true,
          });
          break;
        case "drug":
          await this.fetchMedicationFavorite({
            method: method,
            slug: slug,
            favoritePage: true,
          });
          break;
      }
      await this.getRecommendations(this.user.id);
    },
    async goTo() {
      this.$emit('recClick', {...this.item, type: this.typeName})
      window.open(this.link, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.material {
  max-width: 100%;
  background-color: #fff;
  cursor: pointer;
  border: 1px solid #d2d2d2;

  &:hover {
    .material__title {
      color: #830051;
    }
  }

  &__image-container {
    position: relative;
    width: 100%;
  }

  &__preview {
    width: 100%;
    height: auto;
    aspect-ratio: 16/9;
    object-fit: cover;
    object-position: center;
  }

  &__category {
    padding: 8px 24px;
    width: 100%;
    display: block;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #1f1f1f;
    background-color: rgba(235, 239, 238, 0.8);
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  &__text-container {
    padding: 16px 24px 24px;
    @media screen and (max-width: 1220px) {
      padding: 16px;
    }
  }

  &__tags {
    margin-bottom: 8px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  &__tag {
    padding: 4px 6px;
    border-radius: 99px;
    position: relative;
    display: inline-block;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 13px;
    color: #3c4242;
    text-align: center;
    text-overflow: ellipsis;
    overflow: hidden;
    border: 1px solid #d8dada;
  }

  &__title {
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #3c4242;
    transition: 0.3s;
    position: relative;
    overflow: hidden;
    max-height: 100px;

    &::before {
      width: 100%;
      height: 25px;
      position: absolute;
      top: 75px;
      left: 0;
      display: block;
      content: "";
      background: linear-gradient(0, #fff 0%, rgba(255, 255, 255, 0) 100%);
    }

  
    @media screen and (max-width: 1220px) {
      font-size: 16px;
      line-height: 20px;
    }

    @media screen and (max-width: 767px) {
      font-size: 16px;
      line-height: 20px;
    }
  }

  &__description {
    margin-top: 8px;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
    color: #656969;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    -webkit-box-orient: vertical;
    display: none;
  }

  &__disease {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #830051;
    margin-bottom: 8px;
  }

  &__brands {
    margin-top: 8px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  &__brand {
    padding: 4px 6px;
    border-radius: 99px;
    position: relative;
    display: inline-block;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 13px;
    color: #3c4242;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    border: 1px solid #cbdff7;
    background-color: #cbdff7;
  }
}
</style>